function r(){return function(r){return r.rpcUrls.public.http[0]?{chain:r,rpcUrls:r.rpcUrls.public}:null}}export{r as publicProvider};
